module.exports = "/images/logoNequi.svg";